export let environment =
  import.meta.env.MODE === 'development' ? import.meta.env.VITE_BASE_URL_DEV : import.meta.env.VITE_BASE_URL;
export const linkUrl = import.meta.env.MODE === 'development' ? `https://dev.sez.us` : 'https://sez.us';
export const BaseURL = import.meta.env.MODE === 'development' ? `${import.meta.env.VITE_BASE_URL_DEV}/s3/` : '/s3/';
